import { render, staticRenderFns } from "./request-for-quotes.vue?vue&type=template&id=238a6bc2&scoped=true"
import script from "./request-for-quotes.vue?vue&type=script&lang=js"
export * from "./request-for-quotes.vue?vue&type=script&lang=js"
import style0 from "./request-for-quotes.vue?vue&type=style&index=0&id=238a6bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a6bc2",
  null
  
)

export default component.exports